// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2iIGD","Content":"Button_Content__3UI6z","Ripple":"Button_Ripple__2DDWL","Click":"Button_Click__UpQhq","RippleTrigger":"Button_RippleTrigger__2Tz68"};